import React from "react";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';
import { toast } from 'react-toastify';
import ChangePassword from "./ChangePassword";

import { getMessage } from "CONFIG/i18n";

import { changePasswordAction } from "CONFIG/ActionFactory";

import "../ResetPassword/ResetPassword.less";

class ChangePasswordContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
    };
  }

  handleChangePassword = (data, callback) => {
    changePasswordAction.changePasswordAction(data).then(
      () => {
        toastr.success(`${getMessage("PASSWORD_SET")}`);
        if (callback) callback({ resp: "success" });
        this.props.toggleModal();
      },
      error => {
        if (callback) callback({ resp: "error", error: error });
      }
    );
  };

  displayError = message => {
    toastr.error(message);
  };

  render() {
    return (
      <div>
        <ChangePassword
          handleChangePassword={this.handleChangePassword}
          toggleModal={this.props.toggleModal}
          show={this.props.show}
          isSystemPassword={this.props.isSystemPassword}
          language={this.props.language}
        />
      </div>
    );
  }

  componentWillUnmount() {
    toast.dismiss()
    //toast.removeByType("success");
    //toast.removeByType("error");
  }
}

export default ChangePasswordContainer;
